import { Table, TableBody, TableHead, TableRow, withStyles } from '@material-ui/core';
import { RenderLabel, HeaderCell, RowCell } from '../components';

const styles = (theme) => ({
  tableHead: {
    backgroundColor: theme.printTableHead
  },
  table: {
    margin: 0,
    marginTop: 22,
    marginBottom: 18,
    width: '100%',
    borderRight: `1px solid ${theme.printTableBorder}`,
    borderLeft: `1px solid ${theme.printTableBorder}`
  },
  tableRow: {
    pageBreakInside: 'avoid',
    height: 'auto',
    borderBottom: `1px solid ${theme.printTableBorder}`
  },
  barcodeSubRow: {
    paddingTop: 4,
    paddingBottom: 4,
    textAlign: 'left',
  },
  barcodeCell: {
    textAlign: 'center',
    padding: '8px 0',
  },
});

const TableContainer = (props) => {
  const {
    classes,
    tableData: { tableHeaders, pros }
  } = props;
  return (
    <Table className={classes.table}>
      <TableHead className={classes.tableHead}>
        <TableRow className={classes.tableRow}>
          {tableHeaders.map((cellConfig) => (
            <HeaderCell key={cellConfig.label} style={cellConfig.styles || {}}>
              <RenderLabel label={cellConfig.label} />
            </HeaderCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {pros.map((cellValuesInfoList, rowIndex) => (
          <TableRow key={rowIndex} className={classes.tableRow}>
            {cellValuesInfoList.map((cellInfo, cellIndex) => (
              <RowCell key={`${rowIndex}-${cellIndex}`} style={cellInfo.styles || {}}>
                {cellInfo.value}
              </RowCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default withStyles(styles)(TableContainer);
